import { gql } from 'graphql-tag';

export const CURRENT_USER = gql`
  query {
    currentUser {
      dob
      email
      firstname
      gender
      lastname
      phoneNumber
      roles
      userId
      address
      city
      postalCode
      state
      preferredName
    }
  }
`;
